import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PayService } from '@core/services';
import {
	PROCESS_PAYMENT,
	PROCESS_PAYMENT_SUCCESS,
	PROCESS_PAYMENT_FAILURE,
	CREATE_CUSTOMER_LOGGED,
	CREATE_CUSTOMER_LOGGED_SUCCESS,
	CREATE_CUSTOMER_LOGGED_FAILURE,
} from '@store/actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { IResponseBadRequest, IResponseSuccess } from '@core/interfaces';
import { PayCustomerData } from '@core/models/payment/payment-response';

@Injectable()
export class PayEffects {
	constructor(
		private actions$: Actions,
		private payService: PayService,
	) {}

	processPayment$ = createEffect(() =>
		this.actions$.pipe(
			ofType(PROCESS_PAYMENT),
			mergeMap(({vaultedCardToken, amount, localId, diaLaboralId, isGuest}) => {
				return this.payService
					.processPayment(vaultedCardToken, amount, localId, diaLaboralId, isGuest)
					.pipe(
						map(response => PROCESS_PAYMENT_SUCCESS({ response })),
						catchError(error => of(PROCESS_PAYMENT_FAILURE({ error })))
					);
			})
		)
	);

	createCustomerLogged$ = createEffect(() =>
		this.actions$.pipe(
			ofType(CREATE_CUSTOMER_LOGGED),
			mergeMap(({ customerData }) => {
				if (!customerData) {
					return of(
						CREATE_CUSTOMER_LOGGED_FAILURE({
							error: { message: 'Customer data is required' } as IResponseBadRequest,
						})
					);
				}

				return this.payService.createCustomerLogged(customerData).pipe(
					map((response: IResponseSuccess<PayCustomerData>) => {
						const [customer] = response.data as PayCustomerData[];

						if (!response?.success || !customer?.idCustomer) {
							throw new Error('Invalid customer data response');
						}
						return CREATE_CUSTOMER_LOGGED_SUCCESS({
							customer: {
								idCustomer: customer.idCustomer,
								clienteId: customer.clienteId,
								customerMerchId: customer.customerMerchId,
								fechaCreacion: customer.fechaCreacion,
								fechaActualizacion: customer.fechaActualizacion,
							},
						});
					}),
					catchError(error => of(CREATE_CUSTOMER_LOGGED_FAILURE({ error })))
				);
			})
		)
	);
}
